import {useCallback} from "react";

import {InquiryButtonTypeName} from "../../../constants/inquiry_button_type";
import {AuthModalVariant} from "../../auth/components/auth_modal/AuthModalHeaderVariants";
import {closeFlow, startRegistrationFlow} from "../../auth/state/registration_flow_slice";
import {useAppDispatch} from "../../store/hooks";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {RESERVATION_PLACEMENT_CONFIG} from "../constants/reservation_placement_config";
import {getReservationAuthPlacement} from "../tracking/get_reservation_auth_placement";
import {IReservationAuthState} from "../types/IReservationAuthState";
import {IReservationRequest} from "../types/IReservationRequest";

export interface IStartReservationRegistrationOptions {
    // the placement of the registration that led to the reservation - by default the placement of the reservation button
    amplitudePlacement?: AmplitudeAuthPlacement | null;
    // opens the login form instead of the sign-up form - for a user who has an account but whose session has expired
    showLoginForm?: boolean;
}

export type StartReservationRegistration = (request: IReservationRequest, auth: IReservationAuthState, options?: IStartReservationRegistrationOptions) => void;

/**
 * The only way a reservation (re)opens the registration flow: a verified user lands on the reservation step right away,
 * anyone else goes through the registration and phone steps first.
 * The previous run is closed without marking the unlock choice as dismissed - handing over to the registration is not abandoning it.
 */
export const useStartReservationRegistration = (): StartReservationRegistration => {
    const dispatch = useAppDispatch();

    return useCallback(
        (request, auth, options = {}) => {
            dispatch(closeFlow());
            dispatch(
                startRegistrationFlow({
                    ...auth,
                    // without a user source the registration modal is not rendered
                    userSource: UserSource.APPLICATION,
                    modalVariant: "hidden_prices_variant_b",
                    titleVariant: AuthModalVariant.FREE_RESERVATION,
                    propertyId: request.propertyId,
                    offerId: request.offerId,
                    vendorId: request.vendorId,
                    amplitudePlacement: getReservationAuthPlacement(request.placement, options.amplitudePlacement),
                    gtmSourceSection: RESERVATION_PLACEMENT_CONFIG[request.placement].gtmSourceSection ?? undefined,
                    gtmClickText: InquiryButtonTypeName.FREE_RESERVATION,
                    showLoginForm: options.showLoginForm,
                    reservationRequest: request
                })
            );
        },
        [dispatch]
    );
};
import {useCallback} from "react";

import {InquiryButtonTypeName} from "../../../constants/inquiry_button_type";
import {AuthModalVariant} from "../../auth/components/auth_modal/AuthModalHeaderVariants";
import {closeFlow, startRegistrationFlow} from "../../auth/state/registration_flow_slice";
import {useAppDispatch} from "../../store/hooks";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {RESERVATION_PLACEMENT_CONFIG} from "../constants/reservation_placement_config";
import {getReservationAuthPlacement} from "../tracking/get_reservation_auth_placement";
import {IReservationAuthState} from "../types/IReservationAuthState";
import {IReservationRequest} from "../types/IReservationRequest";

export interface IStartReservationRegistrationOptions {
    // the placement of the registration that led to the reservation - by default the placement of the reservation button
    amplitudePlacement?: AmplitudeAuthPlacement | null;
    // opens the login form instead of the sign-up form - for a user who has an account but whose session has expired
    showLoginForm?: boolean;
}

export type StartReservationRegistration = (request: IReservationRequest, auth: IReservationAuthState, options?: IStartReservationRegistrationOptions) => void;

/**
 * The only way a reservation (re)opens the registration flow: a verified user lands on the reservation step right away,
 * anyone else goes through the registration and phone steps first.
 * The previous run is closed without marking the unlock choice as dismissed - handing over to the registration is not abandoning it.
 */
export const useStartReservationRegistration = (): StartReservationRegistration => {
    const dispatch = useAppDispatch();

    return useCallback(
        (request, auth, options = {}) => {
            dispatch(closeFlow());
            dispatch(
                startRegistrationFlow({
                    ...auth,
                    // without a user source the registration modal is not rendered
                    userSource: UserSource.APPLICATION,
                    modalVariant: "hidden_prices_variant_b",
                    titleVariant: AuthModalVariant.FREE_RESERVATION,
                    propertyId: request.propertyId,
                    offerId: request.offerId,
                    vendorId: request.vendorId,
                    amplitudePlacement: getReservationAuthPlacement(request.placement, options.amplitudePlacement),
                    gtmSourceSection: RESERVATION_PLACEMENT_CONFIG[request.placement].gtmSourceSection ?? undefined,
                    gtmClickText: InquiryButtonTypeName.FREE_RESERVATION,
                    showLoginForm: options.showLoginForm,
                    reservationRequest: request
                })
            );
        },
        [dispatch]
    );
};
